import React from 'react';
import PropTypes from 'prop-types';

const Snow = ({ color }) => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M13.6673 7.58986L13.667 6.4113L10.7821 6.41159L12.8372 4.35622L12.0038 3.52315L9.11552 6.41159H7.58971V4.88593L10.478 1.99734L9.64494 1.16397L7.58971 3.21934V0.333984H6.4113L6.41145 3.21904L4.35622 1.16397L3.523 1.99734L6.41145 4.88579V6.41159H4.88564L1.99719 3.52315L1.16382 4.35622L3.21934 6.41159H0.333984V7.59L3.21904 7.58986L1.16382 9.64523L1.99719 10.4783L4.88564 7.58986H6.41145V9.11537L3.523 12.004L4.35607 12.8375L6.41145 10.7821V13.6673H7.59V10.7824L9.64494 12.8375L10.478 12.004L7.59 9.11552L7.58971 7.58986H9.11537L12.0038 10.4783L12.8372 9.64523L10.782 7.58986H13.6673Z"
      fill={color}
    />
  </svg>
);

Snow.propTypes = {
  color: PropTypes.string.isRequired,
};

export default Snow;
